// redux/store.js
import { configureStore } from '@reduxjs/toolkit';
import tabsReducer from './slices/tabsSlice'; // Слайс с состоянием вкладок
import adminModeReducer from './slices/adminModeSlice'; // Слайс с состоянием adminMode
import isAdminReducer from './slices/isAdminSlice'; // Слайс с состоянием adminMode
import userReducer from './slices/userSlice';
import lessonAccessReducer from './slices/lessonAccessSlice';


const store = configureStore({
  reducer: {
    tabs: tabsReducer, // Редьюсер вкладок
    adminMode: adminModeReducer, // Редьюсер для режима администратора
    isAdmin: isAdminReducer,
    user: userReducer,
    lessonAccess: lessonAccessReducer,
  },
});

export default store;
